
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.5 2.95689C11.7067 2.95689 2.9569 11.7066 2.9569 22.5C2.9569 33.2933 11.7067 42.0431 22.5 42.0431C33.2934 42.0431 42.0431 33.2933 42.0431 22.5C42.0431 11.7066 33.2934 2.95689 22.5 2.95689ZM0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5C45 34.9263 34.9264 45 22.5 45C10.0736 45 0 34.9263 0 22.5ZM13.9428 13.5064C14.5201 12.9291 15.4563 12.9291 16.0336 13.5064L22.939 20.4117L29.8443 13.5064C30.4217 12.9291 31.3578 12.9291 31.9352 13.5064C32.5126 14.0838 32.5126 15.0199 31.9352 15.5973L25.0299 22.5026L31.9352 29.4079C32.5126 29.9853 32.5126 30.9215 31.9352 31.4988C31.3578 32.076 30.4217 32.076 29.8443 31.4988L22.939 24.5935L16.0336 31.4988C15.4563 32.076 14.5201 32.076 13.9428 31.4988C13.3654 30.9215 13.3654 29.9853 13.9428 29.4079L20.848 22.5026L13.9428 15.5973C13.3654 15.0199 13.3654 14.0838 13.9428 13.5064Z","fill":"#DD3B3B"}})])
          )
        }
      }
    